import { Dispatch } from '@reduxjs/toolkit';
import { invoiceDataApi } from 'entities/invoice/details/api';
import { invoiceCloseApi } from 'entities/invoice-report/invoice-close/invoice-close.api';
import { invoiceReportApi } from 'entities/invoice-report/invoice-report.api';

export const refreshInvoiceQueries = (dispatch: Dispatch) => {
  dispatch(invoiceDataApi.util.invalidateTags(['invoice-data']));
  dispatch(invoiceCloseApi.util.invalidateTags(['invoice-closing']));
  dispatch(invoiceReportApi.util.invalidateTags(['invoice-report-rows']));
};

export const refreshInvoicesAfterPayment = async (
  _arg: unknown,
  {
    dispatch,
    queryFulfilled,
  }: {
    dispatch: Dispatch;
    queryFulfilled: Promise<unknown>;
  },
) => {
  try {
    await queryFulfilled;
    refreshInvoiceQueries(dispatch);
  } catch {
    console.error('Failed payment mutation');
  }
};
